import type { DemoScript } from "../types";

/**
 * Do id do passo para a posição dele no roteiro.
 *
 * É o que liga o elemento clicável da tela ao que ele abre: o elemento declara
 * `data-demo-open="calc-modal-open"` e o player pula para lá, porque é o passo
 * atual que monta o modal. O vínculo é por string, então id inexistente
 * devolve `null` em vez de derrubar a tela — o clique só não faz nada.
 */
export function stepIndexById(script: DemoScript, id: string): number | null {
  const index = script.findIndex((step) => step.id === id);
  return index === -1 ? null : index;
}
